// extracted by mini-css-extract-plugin
export default {"creditSection":"creditSection__o5T3DP","creditSectionInfo":"creditSectionInfo__wrnqeB","creditSectionLabel":"creditSectionLabel__YUJp1L"};